import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { fadeUp, staggerContainer } from '@/animations/variants';
import MetricCard from '@/components/cards/MetricCard';

const metrics = [
  {
    title: "Incorporated",
    value: "2022",
    subtitle: "Stable track record",
    prefix: "",
    suffix: "",
  },
  {
    title: "YoY Growth",
    value: 180,
    subtitle: "Consistent scaling",
    prefix: "",
    suffix: "%+",
  },
  {
    title: "Regions",
    value: 5,
    subtitle: "Global presence",
    prefix: "",
    suffix: "+",
  },
];

export default function HeroMetrics() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-surface/50" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          <motion.div 
            className="text-center mb-8 sm:mb-12"
            variants={fadeUp}
          >
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-semibold text-textPrimary mb-3 sm:mb-4">
              Trust Snapshot
            </h2>
            <p className="text-base sm:text-lg text-textSecondary max-w-2xl mx-auto px-4">
              Built on solid foundations with proven growth trajectory
            </p>
          </motion.div>

          <motion.div 
            className="flex justify-center"
            variants={staggerContainer}
          >
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 justify-items-center w-auto">
              {metrics.map((metric, index) => (
                <motion.div
                  key={index}
                  variants={fadeUp}
                >
                  <MetricCard
                    title={metric.title}
                    value={metric.value}
                    subtitle={metric.subtitle}
                    prefix={metric.prefix}
                    suffix={metric.suffix}
                    delay={index * 0.1}
                  />
                </motion.div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}